module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 597
// module chunks = 0